import React from 'react';

const ChevronUp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.696495 5.3465C0.882365 5.34499 1.06086 5.27359 1.19649 5.1465L3.99649 2.3365L6.79649 5.1465C7.07264 5.42264 7.52035 5.42264 7.79649 5.1465C8.07264 4.87035 8.07264 4.42264 7.79649 4.1465L4.49649 0.856495C4.36483 0.722118 4.18462 0.646393 3.99649 0.646393C3.80837 0.646393 3.62816 0.722118 3.49649 0.856495L0.206495 4.1465C0.00332102 4.34556 -0.0591904 4.64778 0.0483378 4.91112C0.155867 5.17445 0.412052 5.34654 0.696495 5.3465Z"
        // eslint-disable-next-line react/prop-types
        fill={props.fill}
      />
    </svg>
  );
};

export default ChevronUp;
